// extracted by mini-css-extract-plugin
module.exports = {"base":"HintBox-module-base","title":"HintBox-module-title","icon":"HintBox-module-icon","warning":"HintBox-module-warning","link":"HintBox-module-link"};